export const subscriptionPlan = {
  name: 'ADarveo Pro',
  monthlyPriceUsd: 99,
  includedScans: 500
} as const;

export const scanPacks = [
  { scans: 1_000, priceUsd: 200 },
  { scans: 5_000, priceUsd: 900 },
  { scans: 10_000, priceUsd: 1_600, popular: true },
  { scans: 25_000, priceUsd: 3_500 },
  { scans: 50_000, priceUsd: 6_000 },
  { scans: 100_000, priceUsd: 10_000, invoice: true }
] as const;

export const formatUsd = (amount: number) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0
  }).format(amount);

export const formatScans = (scans: number) => new Intl.NumberFormat('en-US').format(scans);

export const pricePerScan = (scans: number, priceUsd: number) => priceUsd / scans;

